import { Component, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import cytoscape from 'cytoscape';
import { DataStorageService } from 'src/app/shared/servizi/data-storage.service';
import { DbClicService } from 'src/app/shared/servizi/posizioni/posizioni_db-clic.service';
import { SpinnerService } from 'src/app/shared/servizi/spinner/spinner.service';

@Component({
  selector: 'app-distanza-iponimia',
  templateUrl: './distanza-iponimia.component.html',
  styleUrls: ['./distanza-iponimia.component.css']
})
export class DistanzaIponimiaComponent implements OnInit {
  @Input() cy = cytoscape({});
  @Input() arrayIponimia: any[];
  @Input() arrayEdge: any[];
  @Input() statoNodiIpo: [] = [];
  @Input() statoEdgeIpo: any[];

  valoreFormIpo;
  valoreFormIpe;
  // array iperonimi
  arrayIpe: any[] = [];
  // array iponimi
  arrayIpo: any[] = [];

  focusNode: string;
  @Output() invioArrayIponimia = new EventEmitter<any[]>();
  @Output() invioStato = new EventEmitter<[]>();

  // evento per disabilitare form distanza relazione iponimia
  @Output() disabilitoIpo = new EventEmitter<boolean>();
  @Output() disabilitoIpe = new EventEmitter<boolean>();

  // iponimia
  @Output() valoreFormIpom = new EventEmitter<number>();
  // iperonimia
  @Output() valoreFormIper = new EventEmitter<number>();

  // meronimia
  @Output() valoreFormMeron = new EventEmitter<number>();
  // olonimia
  @Output() valoreFormOlon = new EventEmitter<number>();
  // evento per disabilitare form distanza relazione meronimia
  @Output() disabilitoMero = new EventEmitter<boolean>();
  @Output() disabilitoOlo = new EventEmitter<boolean>();

  // differenzio stato iponimi e stato iperonimi per avere controllo per la disabilitazione del form
  statoIponimi;
  statoIperonimi;
  statoDistIpo;
  statoDistIpe;
  primoClick: boolean = false;

  constructor(
    private dataStorageService: DataStorageService,
    private spinner: SpinnerService,
    private dbClic: DbClicService
  ) { }

  ngOnInit(): void {
  }

  valoreFormIponimia($event) {
    const that = this;
    sessionStorage.getItem('focusNode');
    // stato unico relazione iponimia (sia iponimi che iperonimi)
    that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
    that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));
    // stato iponimi
    that.statoIponimi = JSON.parse(sessionStorage.getItem("statoIponimi"));
    // stato distanza
    that.statoDistIpo = JSON.parse(sessionStorage.getItem("statoDistIpo"));
    this.valoreFormIpo = $event;
    // controllo per togliere errore in console
    if (sessionStorage.getItem('focusNode') !== null) {
      let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
      // array iponimi
      that.arrayIponimia = [];
      // array relazione iponimia unico (sia iponimi che iperonimi)
      this.arrayEdge = [];
      that.arrayIpo = [];

      that.spinner.showSpinner();

      if (this.valoreFormIpe === 0 && this.valoreFormIpo === 0) {
        // se non è stata selezionata la distanza,il nodo focus è al centro del viewport
        this.cy.center(elemSessionStorage);
        this.cy.zoom({
          level: 1,
          position: elemSessionStorage.position()
        });
      }
      // resetto stato se il form è 0 
      if (this.valoreFormIpo === 0) {
        sessionStorage.removeItem('statoNodiIpo');
        sessionStorage.removeItem('statoEdgeIpo');
        let iponimiVisib = elemSessionStorage.incomers();
        this.cy.remove(iponimiVisib);
        // rimuovo nodi
        this.cy.remove(iponimiVisib.sources());
        that.spinner.hideSpinner();
      } else {
        this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'hyponym', this.valoreFormIpo, "incoming").subscribe(iponimo => {
          if (iponimo) {
            that.spinner.hideSpinner();
          }
          sessionStorage.setItem("statoDistIpo", JSON.stringify(iponimo.nodes.length));
          let nodi: any = iponimo.nodes;
          let edges: any = iponimo.edges;
          this.valoreFormIpom.emit(this.valoreFormIpo);
          // se non ci sono sensi recuperati, disabilito il form
          if (nodi.length === 0 && this.statoIponimi === null) {
            this.valoreFormIpom.emit(0);
            this.disabilitoIpo.emit(true);
            that.arrayIpo.length = that.arrayIpo.push(nodi.length);
            that.arrayIponimia = that.arrayIpo.concat(that.arrayIpe);
            // stato relazione iponimia unico (sia iponimi che iperonimi)
            sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
            // stato iponimi
            sessionStorage.setItem("statoIponimi", JSON.stringify(that.arrayIpo.length));
            that.invioArrayIponimia.emit(that.arrayIponimia);
            that.invioStato.emit(that.statoNodiIpo);
          }

          let iponimiVisib: any = elemSessionStorage.predecessors().filter(':visible');
          // controllo per chiudere eventuali nodi visibili con lenght superiore a valore form solo se lo stato è null
          for (var i = 0; i < iponimiVisib.length; i++) {
            if (iponimiVisib[i] !== iponimo.edges[i]) {
              // rimuovo edge
              this.cy.remove(iponimiVisib);
              // rimuovo nodi
              this.cy.remove(iponimiVisib.sources());
            }
          }
          // nodi > 1000
          if (nodi.length > 1000) {
            alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
            that.spinner.hideSpinner();
            // resetto valore a 0 
            this.valoreFormIpom.emit(0);
            // nodi < 1000
          } else {
            for (var i = 0; i < nodi.length; i++) {
              // aggiungo nodi
              this.cy.add([{
                group: "nodes",
                data: {
                  id: iponimo.nodes[i].data.id,
                  label: iponimo.nodes[i].data.label
                }
              }]);
              that.arrayIpo.length = that.arrayIpo.push(iponimo.nodes[i].data.id);
              that.arrayIponimia = that.arrayIpo.concat(that.arrayIpe);
              // stato relazione di iponimia unico (sia iponimi che iperonimi)
              sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
              // stato iponimi
              sessionStorage.setItem("statoIponimi", JSON.stringify(that.arrayIpo.length));
              that.invioArrayIponimia.emit(that.arrayIponimia);
              that.invioStato.emit(that.statoNodiIpo);
              let nodiIpo = this.cy.getElementById(iponimo.nodes[i].data.id);
              that.cy.batch(function () {
                nodiIpo
                  .style('display', 'element')
                  .addClass('label')
                  .addClass('iponimia')
                  ;
              });
            }
          for (var i = 0; i < edges.length; i++) {
            // aggiungo edge
            this.cy.add([{
              group: "edges",
              data: {
                id: iponimo.edges[i].data.id,
                source: iponimo.edges[i].data.source,
                target: iponimo.edges[i].data.target,
                relationType: iponimo.edges[i].data.relationType,
                label: iponimo.edges[i].data.relationType
              }
            }]);
            this.arrayEdge.length = this.arrayEdge.push(this.cy.getElementById(iponimo.edges[i].data.id));
            sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
            let edgesIpo = this.cy.getElementById(edges[i].data.id);
            that.cy.batch(function () {
              edgesIpo
                .style('display', 'element')
                .addClass('edges')
                ;
            });
          }
          that.dbClic.posizioneFormDistanza(elemSessionStorage);
          // controllo se il grafo è fuori dal viewport faccio fit
          if (that.isGraphOutOfView() === true) {
            that.cy.fit();
          }
        }
        });
      }

    }
  }

  valoreFormIperonimia($event) {
    const that = this;
    sessionStorage.getItem('focusNode');
    // stato iperonimi
    that.statoIperonimi = JSON.parse(sessionStorage.getItem("statoIperonimi"));
    // stato unico relazione iponimia (sia iponimi che iperonimi)
    that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
    that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));
    // stato distanza
    that.statoDistIpe = JSON.parse(sessionStorage.getItem("statoDistIpe"));
    this.valoreFormIpe = $event;
    // controllo per togliere errore in console
    if (sessionStorage.getItem('focusNode') !== null) {
      let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
      // array relazione iponimia unico (sia iponimi che iperonimi)
      that.arrayIponimia = [];
      this.arrayEdge = [];
      // array iperonimi
      that.arrayIpe = [];
      that.spinner.showSpinner();
      if (this.valoreFormIpe === 0 && this.valoreFormIpo === 0) {
        // se non è stata selezionata la distanza
        // il nodo focus è al centro del viewport
        this.cy.center(elemSessionStorage);
        this.cy.zoom({
          level: 1,
          position: elemSessionStorage.position()
        });
      }
      // resetto stato se il form è 0 
      if (this.valoreFormIpe === 0) {
        sessionStorage.removeItem('statoNodiIpo');
        sessionStorage.removeItem('statoEdgeIpo');
        let iperonimiVisib = elemSessionStorage.outgoers();
        // rimuovo edge
        this.cy.remove(iperonimiVisib);
        // rimuovo nodi
        this.cy.remove(iperonimiVisib.targets());
        that.spinner.hideSpinner();
      } else {
        this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'hyponym', this.valoreFormIpe, "outgoing").subscribe(iperonimo => {
          if (iperonimo) {
            that.spinner.hideSpinner();
          }
          sessionStorage.setItem("statoDistIpe", JSON.stringify(iperonimo.nodes.length));
          this.valoreFormIper.emit(this.valoreFormIpe);
          let nodi: any = iperonimo.nodes;
          let edges: any = iperonimo.edges;
          // se non ci sono sensi recuperati, disabilito il form solo se lo stato è null
          if (nodi.length === 0 && this.statoIperonimi === null) {
            this.valoreFormIper.emit(0);
            this.disabilitoIpe.emit(true);
            that.arrayIpe.length = that.arrayIpe.push(nodi.length);
            that.arrayIponimia = that.arrayIpe.concat(that.arrayIpo);
            // stato iperonimi
            sessionStorage.setItem("statoIperonimi", JSON.stringify(that.arrayIpe.length));
            // stato relazione iponimia unico (sia iponimi che iperonimi)
            sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
            that.invioArrayIponimia.emit(that.arrayIponimia);
            that.invioStato.emit(that.statoNodiIpo);
          }

          let iperonimiVisib: any = elemSessionStorage.successors().filter(':visible');
          // controllo per chiudere eventuali nodi visibili con lenght superiore a valore form
          for (var i = 0; i < iperonimiVisib.length; i++) {
            if (iperonimiVisib[i] !== iperonimo.edges[i]) {
              // rimuovo edge
              this.cy.remove(iperonimiVisib);
              // rimuovo nodi
              this.cy.remove(iperonimiVisib.targets());
            }
          }
          // nodi > 1000
          if (nodi.length > 1000) {
            alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
            that.spinner.hideSpinner();
            // resetto valore a 0 
            this.valoreFormIper.emit(0);
            // nodi < 1000
          } else {
            for (var i = 0; i < nodi.length; i++) {
              // aggiungo nodi
              this.cy.add([{
                group: "nodes",
                data: {
                  id: iperonimo.nodes[i].data.id,
                  label: iperonimo.nodes[i].data.label
                }
              }]);
              that.arrayIpe.length = that.arrayIpe.push(iperonimo.nodes[i].data.id);
              that.arrayIponimia = that.arrayIpe.concat(that.arrayIpo);
              // stato iperonimi
              sessionStorage.setItem("statoIperonimi", JSON.stringify(that.arrayIpe.length));
              // stato relazione iponimia unico (sia iponimi che iperonimi)
              sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
              that.invioArrayIponimia.emit(that.arrayIponimia);
              that.invioStato.emit(that.statoNodiIpo);
              let nodiIpe = this.cy.getElementById(iperonimo.nodes[i].data.id);
              that.cy.batch(function () {
                nodiIpe
                  .style('display', 'element')
                  .addClass('label')
                  .addClass('iponimia')
                  ;
              });
            }

            for (var i = 0; i < edges.length; i++) {
              // aggiungo edge
              this.cy.add([{
                group: "edges",
                data: {
                  id: iperonimo.edges[i].data.id,
                  source: iperonimo.edges[i].data.source,
                  target: iperonimo.edges[i].data.target,
                  relationType: iperonimo.edges[i].data.relationType,
                  label: iperonimo.edges[i].data.relationType
                }
              }]);
              this.arrayEdge.length = this.arrayEdge.push(this.cy.getElementById(iperonimo.edges[i].data.id));
              sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
              let edgesIpe = this.cy.getElementById(iperonimo.edges[i].data.id);
              that.cy.batch(function () {
                edgesIpe
                  .style('display', 'element')
                  .addClass('edges')
                  ;
              });
            }
            //  servizio posizionamento
            that.dbClic.posizioneFormDistanza(elemSessionStorage);
            // controllo se il grafo è fuori dal viewport faccio fit
            if (that.isGraphOutOfView() === true) {
              that.cy.fit();
            }
          }
        });
      }
    }
  }
  isGraphOutOfView() {
    const width = this.cy.width();
    const height = this.cy.height();
    const rbb = this.cy.elements().renderedBoundingbox({ includeOverlays: false, includeNodes: true });

    return rbb.x1 < 0 || rbb.y1 < 0 || rbb.x2 > width || rbb.y2 > height;
  }
}
